module.exports = __webpack_public_path__ + "assets/img/config-table-1b67d269.png";